module.exports = __webpack_public_path__ + "static/media/EMP.2cf9e029.png";